// PATH: src/components/catalog/CatalogContext.tsx
import * as React from "react";
import type { CatalogIndex, NodeRef } from "./catalogModel";

export interface CatalogContextValue {
  index: CatalogIndex;
  /** Relit le catalogue (après une écriture). */
  reload: () => Promise<void>;
  /** Ouvre un nœud (programme, étape, niveau). */
  select: (node: NodeRef) => void;
}

const Ctx = React.createContext<CatalogContextValue | null>(null);

export const CatalogProvider = Ctx.Provider;

export const useCatalog = (): CatalogContextValue => {
  const v = React.useContext(Ctx);
  if (!v) throw new Error("useCatalog hors de <CatalogProvider>");
  return v;
};
